import 'babel-polyfill';
import 'whatwg-fetch';
// eslint-disable-next-line
import { CONFIG, KEYCODES, BODY_TAB_FOCUS_CLASS } from "./config";
import {
  isIE11, isEdge, isIOS, isSafari,
} from '../tools/helpers';
import '../../scss/_index.scss';

/* Vue Applications and GraphQL Connector */
import GraphQLConnector from '../graphql';
import BfvMatchday from '../../templates/partials/singleFileComponents/matchday/bfv-matchday';
import BfvSearch from '../../templates/partials/singleFileComponents/search/search';

/* REST API Handling */
import ApiConnector from '../restApi';

/* Global Event-Handler */
import getEventHandlerResize from './ResizeHandler';
import getEventHandlerScroll from './ScrollHandler';
import addTabFocusHandler from './TabFocusHandler';

import TableInitializer from './Tables/tableInitializer';

import initModules, { setModuleClasses } from './initModules';
import moduleClasses from './moduleClasses';

// global functions
window.divae = window.divae || {};

if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-extend-native,func-names
  String.prototype.startsWith = function (searchString, position) {
    // eslint-disable-next-line no-param-reassign
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

const mainInit = () => {
  // initialize global EventHandlers
  getEventHandlerResize();
  getEventHandlerScroll();

  // initialize JS modules
  setModuleClasses(moduleClasses);
  initModules({ rootElement: document });
};

// initialize JS for mobile tables as we have no control over classes in the rich text content
const tableInit = () => {
  const tableInitializer = new TableInitializer();
  tableInitializer.tableInit();
};

window.addEventListener('DOMContentLoaded', () => {
  // Enabele REST API connections
  const restApi = new ApiConnector();
  restApi.init();
  window.divae.restApi = restApi;

  // Add IE-11 Body-Class
  if (isIE11()) {
    document.querySelector('body').classList.add('ie11');
  }

  // Add Edge Body-Class
  if (isEdge()) {
    document.querySelector('body').classList.add('edge');
  }

  // Add Safari Body-Class
  if (isSafari()) {
    document.querySelector('body').classList.add('safari');
  }

  // Add Edge Body-Class
  if (isIOS()) {
    document.querySelector('body').classList.add('ios');
  }

  addTabFocusHandler(KEYCODES, document.body, BODY_TAB_FOCUS_CLASS);

  // initialize static JS Modules
  mainInit();

  // initialize tables
  tableInit();

  // Initialize GraphQL connector and expose globally for Vue 3 components
  const graphQLConnector = new GraphQLConnector();
  graphQLConnector.init();
  window.divae.graphQLConnector = graphQLConnector;

  // Register Vue 3 web components
  customElements.define('bfv-search', BfvSearch);
  customElements.define('bfv-matchday', BfvMatchday);
});

